import { useTranslation } from 'react-i18next';
import { Button, Modal, Text } from '@shared/widgets';

interface IDeleteUserModalProps {
  open: boolean;
  close: () => void;
  deleteUser: () => void;
}

export const DeleteUserModal = (props: IDeleteUserModalProps) => {
  const { t } = useTranslation('user');

  return (
    <Modal isOpen={props.open} onClose={props.close} title={t('sidebar.modals.deleteUser.title')}>
      <Text className='text-center'>{t('sidebar.modals.deleteUser.description')}</Text>
      <div className='mt-6 flex gap-2'>
        <Button color='outlined' fullWidth onClick={props.close}>
          {t('buttons.close', { ns: 'common' })}
        </Button>
        <Button color='primary' fullWidth onClick={props.deleteUser}>
          {t('buttons.delete', { ns: 'common' })}
        </Button>
      </div>
    </Modal>
  );
};
